const langInfo = {
  'en-GB': { name: 'English', shorthand: 'En' },
  'zh-CN': { name: '简体中文', shorthand: 'Cn' },
  fr: { name: 'Français', shorthand: 'Fr' },
  pt: { name: 'Português', shorthand: 'Pt' },
  es: { name: 'Español', shorthand: 'Es' },
  zh: { fallback: 'zh-CN' },
  'zh-HK': { fallback: 'zh-CN' },
  en: { fallback: 'en-GB' },
};

export const defaultLanguage = 'en-GB';

export const getSupportedLanguages = () =>
  Object.entries(langInfo)
    .filter(e => e[1].name)
    .map(e => e[0]);

export const getLanguageOptions = () => {
  const supportedLanguages = getSupportedLanguages();
  return supportedLanguages.map(languageCode => ({
    text: langInfo[languageCode].name,
    locale: languageCode,
  }));
};

export const getWhitelistedLanguages = () => Object.keys(langInfo);

export const getCanonicalLanguage = (language = '') => {
  language = language.toLowerCase();
  language = langInfo[language] ? language : language.substring(0, 2);
  if (langInfo[language]) {
    return langInfo[language].fallback || language;
  }
  return defaultLanguage;
};

export const getLanguageInfo = language =>
  langInfo[getCanonicalLanguage(language)];

export const hashKey = defaultValue => {
  let hashedValue = defaultValue.replace(/<\/?\d+>/g, '');
  hashedValue = hashedValue.replace(/(\{\{|\}\})/g, '#');
  hashedValue = hashedValue.replace(/[^a-zA-Z#@]/g, '_');
  return hashedValue;
};
